import $foreign from "./foreign.cjs";
var naturalKeyImpl = $foreign.naturalKeyImpl;
export { naturalKeyImpl };
